import { canUseDOM } from "./dom"

export const getExpirableLocalStorage = (key: string) => {
  if (!canUseDOM()) return null
  const expiryTimeMilliSeconds = +(
    window.localStorage.getItem(`${key}ExpiryTime`) || 0
  )
  if (expiryTimeMilliSeconds && expiryTimeMilliSeconds > Date.now()) {
    return window.localStorage.getItem(key)
  } else {
    window.localStorage.removeItem(key)
    window.localStorage.removeItem(`${key}ExpiryTime`)
  }
  return null
}

export const setExpirableLocalStorage = (
  key: string,
  value: string,
  seconds = 365 * 24 * 60 * 60,
) => {
  if (!canUseDOM()) return
  window.localStorage.setItem(key, value)
  const expiryTimeMilliSeconds = Date.now() + seconds * 1000
  window.localStorage.setItem(`${key}ExpiryTime`, `${expiryTimeMilliSeconds}`)
}

export const removeExpirableLocalStorage = (key: string) => {
  if (!canUseDOM()) return
  window.localStorage.removeItem(key)
  window.localStorage.removeItem(`${key}ExpiryTime`)
}

export const getSortTermLocalStorage = (key: string) => {
  if (!canUseDOM()) return null
  const expiryTimeMilliSeconds = +(
    window.localStorage.getItem(`${key}ExpiryTime`) || 0
  )
  if (expiryTimeMilliSeconds && expiryTimeMilliSeconds > Date.now()) {
    return window.localStorage.getItem(key)
  }
  return null
}

export const setSortTermLocalStorage = (
  key: string,
  value: string,
  seconds = 3600,
) => {
  if (!canUseDOM()) return
  window.localStorage.setItem(key, value)
  const expiryTimeMilliSeconds = Date.now() + seconds * 1000
  window.localStorage.setItem(`${key}ExpiryTime`, `${expiryTimeMilliSeconds}`)
}
